import generateDefaultSchema from '../../utils/apiSchemaGenerator';

const postCommentsEndpointSchema = comment => (
  generateDefaultSchema('comments', {
    comment,
  })
);

export default postCommentsEndpointSchema;



// WEBPACK FOOTER //
// ./src/containers/VCComments/schemas.js